import { FC1sdpbda2hq7ca as FC } from '../../../../kotlin-react/react/FC.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NamedFCClass;
function NamedFC() {
  if (NamedFCClass === VOID) {
    class $ {
      constructor(function_0) {
        this.y1m_1 = function_0;
        this.z1m_1 = null;
      }
      a1n(t, property) {
        var tmp0_elvis_lhs = this.z1m_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = FC(property.callableName, this.y1m_1);
          this.z1m_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'NamedFC');
    NamedFCClass = $;
  }
  return NamedFCClass;
}
function nfc(function_0) {
  return new (NamedFC())(function_0);
}
//region block: exports
export {
  nfc as nfcrfe5635r1kf5,
};
//endregion

//# sourceMappingURL=ReactFunction.mjs.map
